import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash'
import MemberServices from '../services/MemberService';
import { batch } from 'react-redux'
import OddsPageActions from "../components/CompactView/OddsPageComponent/OddsPageActions";
import {SportsSlice} from "./SportsSlice";
import Constants from '../common/Constants';

export const FavouritesSlice = createSlice({
    name: 'FavouritesSlice',
    initialState:{
        loading: false,
        hasErrors: false,
        favourites: [],
        isAllowUpdateSportsbook: true,
        isAllowFetchFavourites: true
    },
    reducers: {
      getFavourites: state => {
        state.loading = true
      },
      getFavouritesSuccess: (state, {payload}) => {
        state.loading = false
        state.hasError = false
        state.favourites = payload
      },
      getFavouritesFailure: state => {
        state.loading = false
        state.hasErrors = true
      },
      updateIsAllowUpdateSportsbook: (state, {payload}) => {
        state.isAllowUpdateSportsbook = payload
      },
      updateIsAllowFetchFavourites: (state, {payload}) => {
        state.isAllowFetchFavourites = payload
      }
    },
  });
  
  export const {
    getFavourites,
    getFavouritesSuccess,
    getFavouritesFailure,
    updateIsAllowUpdateSportsbook,
    updateIsAllowFetchFavourites
  } = FavouritesSlice.actions
  export const favouritesSelector = state => state.FavouritesSlice
  export default FavouritesSlice.reducer;

  export const fetchFavouriteSports = (eventsId, leaguesId) => {
    return async (dispatch, getState) => {
      dispatch(getFavourites())
      try {
        const eventIds = eventsId.map((item) => {
          if(item && item.id) {
            return item.id.toString().includes('_') ?  (item.eventId || 0) : item.id;
          }
        });
        const leagueIds = leaguesId.map((item) => item.id);
        const response =  await MemberServices.getCompactFavouriteSports(eventIds.flat().join(','), leagueIds.join(',')).then(res => {
          return res.data;
        }).catch(e => {
          dispatch(getFavouritesFailure());
        });
        batch( () => {
          const leagues = _.get(response, 'leagues', []);
          const events = _.get(response, 'events', []);
          let eventsWithDate = [];
          let leaguesWithDate = [];
          let eventNotEndYet = [];
          let leagueNotEndYet = [];
          events.forEach((value, index) => {
            if(value.sportId === Constants.TENNIS_ID && window.env.isUseNewTennisLayout) {
              const favEvent = eventsId.reduce((frEvent, val) => {
                const isExistEvent = eventsWithDate.some(event => event.id === val.id);
                const isValid = val && val.id && !isExistEvent && (val.id.toString().includes('_') ? val.id.toString().includes(`${value.id}`) : value.id === val.id);
                if(isValid) {
                  const ev = {
                    id: val.id,
                    date: val.date,
                    leagueId: value.leagueId,
                    name: value.name,
                    sportId: value.sportId
                  }
                  frEvent.push(ev);
                }
                return frEvent;
              }, []);
              eventsWithDate.push(...favEvent);
            } else {
              const item = eventsId.filter(val=>val && val.id && (val.id.toString().includes('_') ? val.id.toString().includes(`${value.id}`) : value.id === val.id));
              value.date = item && item[0] ? item[0].date: 0;
              if(item[0] && item[0].id && item[0].id.toString().includes('_')) {
                value.id = item && item[0] ? item[0].id: 0;
              }
              eventsWithDate.push(value);
            }
          });
          leagues.forEach(value => {
            let item = leaguesId.filter(val => value.id === val.id);
            value.date = item && item[0] ? item[0].date: 0
            leaguesWithDate.push(value)
          })

          const isAuth = getState().AccountsSlice.user.auth
          const options = getState().SportsSlice.options
          const isAllowUpdateSportsbook = getState().FavouritesSlice.isAllowUpdateSportsbook
          const { favouriteData } = options;
          if (favouriteData && (favouriteData.eventIds || favouriteData.leagueIds) && isAllowUpdateSportsbook) {
            events.forEach(value => {
              const item = favouriteData.eventIds.filter(val => val && val.id && (val.id.toString().includes('_') ? val.id.toString().includes(`${value.id}`) : value.id === val.id));
              eventNotEndYet.push(...item);
            });
            leagues.forEach(value => {
              const item = favouriteData.leagueIds.filter(val => val && val.id && (val.id.toString().includes('_') ? val.id.toString().includes(`${value.id}`) : value.id === val.id));
              leagueNotEndYet.push(...item);
            });
            const eventsFv = _.uniqWith(eventNotEndYet);
            const leaguesFv = _.uniqWith(leagueNotEndYet);
            const favData = { ...favouriteData, eventIds: eventsFv, leagueIds: leaguesFv };
            if (isAuth && OddsPageActions.validNumberFavorite(favouriteData.leagueIds, favouriteData.eventIds)) {
              OddsPageActions.updateSportsbookFavoriteByUserId(favData).then(res => {
                if (res) {
                  dispatch(SportsSlice.actions.updateFavouritesOptions({favouriteData: favData}));
                }
              });
            } else {
              dispatch(SportsSlice.actions.updateFavouritesOptions({favouriteData: favData}));
            }
            dispatch(updateIsAllowUpdateSportsbook(false))
          }
          const favourites = {
            events: _.uniq(eventsWithDate),
            leagues: _.uniq(leaguesWithDate)
          }
          dispatch(getFavouritesSuccess(favourites))
        })
        dispatch(updateIsAllowFetchFavourites(false))
      } catch (error) {
        dispatch(getFavouritesFailure())
      }
    }
  }


// WEBPACK FOOTER //
// ./src/app/slices/FavouritesSlice.js